var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import ShowIf from "../../App/ShowIf";
import { DocumentLanguage, TemplateLabel } from "../../Layout";
import { Icon } from "../../Layout/Icon";
import TimelineViewer from "../../Timeline/components/TimelineViewer";
import { caseTemplate, matterTemplate } from "../../Timeline/utils/timelineFixedData";
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormatMetadata } from "../containers/FormatMetadata";

class ShowMetadata extends Component {
  render() {
    const { entity, showTitle, showType, relationships, showSubset, groupGeolocations } =
    this.props;
    let header = '';
    if (showTitle || showType) {
      let title = '';
      if (showTitle) {
        title = /*#__PURE__*/
        _jsx("div", {}, void 0, /*#__PURE__*/
        _jsx(Icon, { className: "item-icon item-icon-center", data: entity.icon }), /*#__PURE__*/
        _jsx("h1", { className: "item-name" }, void 0,
        entity.title, /*#__PURE__*/
        _jsx(DocumentLanguage, { doc: Immutable.fromJS(entity) })
        )
        );

      }
      const type = showType ? /*#__PURE__*/_jsx(TemplateLabel, { template: entity.template }) : '';
      header = /*#__PURE__*/
      _jsx("div", { className: "item-info" }, void 0,
      title,
      type
      );

    }

    return /*#__PURE__*/(
      _jsx("div", { className: "view" }, void 0,
      header, /*#__PURE__*/

      _jsx(ShowIf, { if: entity.template === caseTemplate || entity.template === matterTemplate }, void 0, /*#__PURE__*/
      _jsx("dl", { className: "metadata-timeline-viewer" }, void 0, /*#__PURE__*/
      _jsx("dd", {}, void 0, /*#__PURE__*/
      _jsx(TimelineViewer, { entity: entity })
      )
      )
      ), /*#__PURE__*/
      _jsx(FormatMetadata, {
        entity: entity,
        relationships: relationships,
        showSubset: showSubset,
        groupGeolocations: groupGeolocations,
        renderLabel: (prop, label) => !prop.noLabel && label,
        highlight: this.props.highlight,
        excludePreview: this.props.excludePreview }
      )
      ));

  }
}
ShowMetadata.defaultProps = {
  showSubset: undefined,
  groupGeolocations: false,
  highlight: [],
  excludePreview: false
};













const mapStateToProps = ({ templates }) => ({ templates });

export { ShowMetadata };
export default connect(mapStateToProps)(ShowMetadata);